import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutation';
import actions from './actions';

Vue.use(Vuex)

const files = require.context('./modules', false, /\.js$/)
const modules = {}

files.keys().forEach(key => {
    modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

export default new Vuex.Store({
    state: {
        developHistoryActionDate:[],
        developHistoryActionList:[],
        developCurrentThemeKey:"default",
        developMarketModuleList:[],
        developCustomModuleList:[]
    },
    getters: {
        getDevelopHistoryActionList(state) {
            return state.developHistoryActionList
        },
        /**
         * 获取当前开发环境的主题key
         * @param {*} state 
         * @returns 
         */
        getDevelopCurrentThemeKey(state){
            // alert(state.developCurrentThemeKey);
            return state.developCurrentThemeKey;
        },
        getDevelopMarketModuleList(state){
            return state.developMarketModuleList
        },
        getDevelopCustomModuleList(state){
            return state.developCustomModuleList
        }
    },
    mutations: mutations,
    actions: actions,
    modules
})